module.exports = __webpack_public_path__ + "images/bg-user-case_24d1c8239ceffdd821a596e08fa7f2fd.png";